// extracted by mini-css-extract-plugin
export var brand = "_2f-9";
export var button = "_2f-0";
export var chevron = "_2f-v";
export var chevronButton = "_2f-w";
export var content = "_2f-n";
export var danger = "_2f-g";
export var dangerOutlined = "_2f-h";
export var dark = "_2f-l";
export var darkTheme = "_2f-c";
export var extraSmall = "_2f-4";
export var fullWidth = "_2f-8";
export var ghost = "_2f-d";
export var gray = "_2f-t";
export var icon = "_2f-p";
export var iconButton = "_2f-s";
export var iconButtonBorder = "_2f-x";
export var iconButtonBorderDark = "_2f-y";
export var iconButtonBorderLight = "_2f-z";
export var iconLeft = "_2f-q";
export var iconRight = "_2f-r";
export var large = "_2f-1";
export var light = "_2f-m";
export var medium = "_2f-2";
export var micro = "_2f-5";
export var nano = "_2f-7";
export var outlined = "_2f-k";
export var pending = "_2f-a";
export var primary = "_2f-i";
export var shadow = "_2f-o";
export var small = "_2f-3";
export var solidLight = "_2f-e";
export var solidLightBrand = "_2f-f";
export var spinner = "_2f-u";
export var transparent = "_2f-j";
export var warning = "_2f-b";
export var wideNano = "_2f-6";